import DefaultModal from "../default_modal";
import { Container, InnerContainer, Column, Label, Input, Button, ButtonDisplay } from './styles'
import Swal from "sweetalert2";
import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { userService } from "../../services/userService";

const ResetPassword = ({ isOpen, onClose, children }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const currentUser = useSelector((state) => state.user.currentUser);

  const handleSubmitPassword = async () => {
    try {
      await userService.updatePassword(
        currentUser.id,
        currentPassword,
        newPassword
      );

      Swal.fire({
        title: 'Concluído',
        text: 'Sua senha foi alterada com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
    } catch (error) {
      console.error('Failed to change password:', error);
      Swal.fire({
        title: 'Erro',
        text: 'Verifique as senhas e tente novamente.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <DefaultModal isOpen={isOpen} onClose={onClose} children={children}>
      <Container>
        <InnerContainer>
          <Column>
            <Label for="current_password">Senha atual:</Label>
            <Input
              type="password"
              id="current_password"
              name="current_password"
              value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)}
            />
          </Column>
          <Column>
            <Label for="new_password">Nova senha:</Label>
            <Input
              type="password"
              id="new_password"
              name="new_password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
            />
          </Column>
        </InnerContainer>
        <ButtonDisplay>
          <Button onClick={handleSubmitPassword}>Salvar</Button>
        </ButtonDisplay>
      </Container>
    </DefaultModal>
  );
};

export default ResetPassword;
